import {
    IconCancel,
    IconChevronCollapse,
    IconChevronExpand,
    IconEdit
} from '../../componentes/Icons';
import './GestaoServicos.css';

const ServicesSection = ({
    newServiceName,
    setNewServiceName,
    newServicePrice,
    setNewServicePrice,
    newServiceDuration,
    setNewServiceDuration,
    newServiceCategory,
    setNewServiceCategory,
    handleAddService,
    services,
    collapsedCategories,
    toggleCategory,
    editingPriceId,
    editingPrice,
    setEditingPrice,
    setEditingPriceId,
    handleUpdateServicePrice,
    editingServiceId,
    editingDuration,
    setEditingDuration,
    setEditingServiceId,
    handleUpdateServiceDuration,
    handleDeleteService
}) => {
    const categories = ['Geral', 'Cabelo', 'Barba', 'Combos', 'SPA & Química', 'Kids', 'Tratamento'];

    return (
        <div className="section-services fade-in">
            <div className="admin-grid-layout">
                <div className="admin-card">
                    <h3 className="card-title">Novo Serviço</h3>
                    <div className="modern-form">
                        <div className="form-group">
                            <label>Nome do Serviço</label>
                            <input
                                type="text"
                                placeholder="Ex: Corte Degradê"
                                value={newServiceName}
                                onChange={(e) => setNewServiceName(e.target.value)}
                                className="modern-input"
                            />
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Preço</label>
                                <input
                                    type="text"
                                    value={newServicePrice}
                                    onChange={(e) => setNewServicePrice(e.target.value)}
                                    className="modern-input"
                                />
                            </div>
                            <div className="form-group">
                                <label>Duração</label>
                                <input
                                    type="text"
                                    placeholder="Ex: 20 min ou 1h 30min"
                                    value={newServiceDuration}
                                    onChange={(e) => setNewServiceDuration(e.target.value)}
                                    className="modern-input"
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Categoria</label>
                            <select
                                value={newServiceCategory}
                                onChange={(e) => setNewServiceCategory(e.target.value)}
                                className="modern-input"
                            >
                                {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                            </select>
                        </div>
                        <button
                            className="modern-btn primary full-width"
                            onClick={handleAddService}
                        >Adicionar Serviço</button>
                    </div>
                </div>

                {categories.map(cat => {
                    const catServices = services.filter(s => s.category === cat);
                    if (catServices.length === 0) return null;

                    return (
                        <div key={cat} className={`admin-card category-card ${collapsedCategories.includes(cat) ? 'is-collapsed' : ''}`}>
                            <div
                                className="category-header-row clickable"
                                onClick={() => toggleCategory(cat)}
                            >
                                <h3 className="card-title" style={{ marginBottom: 0 }}>
                                    {cat} <span className="category-count">({catServices.length})</span>
                                </h3>
                                <span className="toggle-icon">
                                    {collapsedCategories.includes(cat) ? <IconChevronExpand /> : <IconChevronCollapse />}
                                </span>
                            </div>

                            {!collapsedCategories.includes(cat) && (
                                <div className="service-items-grid fade-in">
                                    {catServices.map(service => (
                                        <div key={service.id} className="service-mini-card">
                                            <div className="service-info">
                                                <h4>{service.name}</h4>
                                                <div className="service-details-row">
                                                    <div className="service-meta-tags">
                                                        {editingPriceId === service.id ? (
                                                            <div className="inline-edit-field">
                                                                <input
                                                                    type="text"
                                                                    className="settings-input small price-input"
                                                                    value={editingPrice}
                                                                    onChange={(e) => setEditingPrice(e.target.value)}
                                                                    onBlur={() => handleUpdateServicePrice(service.id)}
                                                                    onKeyPress={(e) => e.key === 'Enter' && handleUpdateServicePrice(service.id)}
                                                                    autoFocus
                                                                />
                                                            </div>
                                                        ) : (
                                                            <span
                                                                className="item-detail clickable-edit"
                                                                onClick={() => {
                                                                    setEditingPriceId(service.id);
                                                                    setEditingPrice(service.price);
                                                                }}
                                                            >
                                                                {service.price} <IconEdit />
                                                            </span>
                                                        )}

                                                        <span className="detail-separator">•</span>

                                                        {editingServiceId === service.id ? (
                                                            <div className="inline-edit-field">
                                                                <input
                                                                    type="text"
                                                                    className="settings-input small duration-input"
                                                                    value={editingDuration}
                                                                    onChange={(e) => setEditingDuration(e.target.value)}
                                                                    onBlur={() => handleUpdateServiceDuration(service.id)}
                                                                    onKeyPress={(e) => e.key === 'Enter' && handleUpdateServiceDuration(service.id)}
                                                                    autoFocus
                                                                />
                                                            </div>
                                                        ) : (
                                                            <span
                                                                className="item-detail clickable-edit"
                                                                onClick={() => {
                                                                    setEditingServiceId(service.id);
                                                                    setEditingDuration(service.duration || '30 min');
                                                                }}
                                                            >
                                                                {service.duration || '30 min'} <IconEdit />
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="action-buttons">
                                                <button
                                                    className="action-btn cancel"
                                                    onClick={() => handleDeleteService(service.id)}
                                                ><IconCancel /></button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ServicesSection;
